<template>
  <div class="wrapper" >
    <div class="loading" v-if="!m_loading">
      <img :src="loading" alt="">
    </div>
   
    <side-bar v-if="m_loading">
      
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/sistema/overview">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Dashboard</p>
      </sidebar-link>
      <sidebar-link to="/sistema/Manifestacao">
        <i class="nc-icon nc-notes"></i>
        <p>Manifestações</p>
      </sidebar-link>
      <sidebar-link to="/sistema/cidadaos">
        <i class="nc-icon nc-circle-09"></i>
        <p>Usuarios</p>
      </sidebar-link>
      <sidebar-link to="/sistema/formulario_manifestacao" >
        <i class="nc-icon nc-notes"></i>
        <p>Abrir Manifestação</p>
      </sidebar-link>
      <h6 class="nav text-blank" style="margin-bottom:20px;padding-left: 20px;padding-right: 20px;" v-show="funcoes.administrador==1">
        <hr style="border-top: 1px solid rgb(255 255 255 / 0.3);">
          <span class="docs-normal" style="margin-left:10px;">SUPORTE</span>
      </h6>
      <sidebar-link to="/sistema/usuario" v-show="funcoes.administrador==1" >
        <i class="nc-icon nc-circle-09"></i>
        <p>Gestores </p>
      </sidebar-link>
      <!--<sidebar-link to="/sistema/permissao" v-if="user.admin">
        <i class="nc-icon nc-settings-gear-64"></i>
        <p>Grupos</p>
      </sidebar-link>-->
      <sidebar-link to="/sistema/departamentos" v-show="funcoes.administrador==1" >
        <i class="nc-icon nc-bullet-list-67"></i>
        <p>Unidade Organizacional</p>
      </sidebar-link>


      <h6 class="nav text-blank" style="margin-bottom:20px;padding-left: 20px;padding-right: 20px;" v-show="funcoes.id==1" >
        <hr style="border-top: 1px solid rgb(255 255 255 / 0.3);">
          <span class="docs-normal" style="margin-left:10px;">LOGS</span>
      </h6>
      <sidebar-link to="/sistema/log_geral" v-show="funcoes.id==1">
        <i class="nc-icon nc-bullet-list-67"></i>
        <p>Log Geral</p>
      </sidebar-link>
      <sidebar-link to="/sistema/log_cidadao" v-show="funcoes.id==1">
        <i class="nc-icon nc-bullet-list-67"></i>
        <p>Log Cidadao</p>
      </sidebar-link>
      <sidebar-link to="/sistema/log_manifestacao" v-show="funcoes.id==1">
        <i class="nc-icon nc-bullet-list-67"></i>
        <p>Log Manifestacao</p>
      </sidebar-link>
      <sidebar-link to="/sistema/log_mov_manifestacao" v-show="funcoes.id==1">
        <i class="nc-icon nc-bullet-list-67"></i>
        <p>Log Movimentacao</p>
      </sidebar-link>

      
    </side-bar>
    <div class="main-panel" v-if="m_loading">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style >
   /* dashboard */
   .text-blank{
     color:#8898aa;
   }
   .sidebar:before, body > .navbar-collapse:before {
        opacity: 10;
        background: #486bb9;
    }
    .sidebar[data-color="black"]:after, body > .navbar-collapse[data-color="black"]:after {
        background: -webkit-gradient(linear, left top, left bottom, from(#486bb9), to(#0e0e0e));
        background: linear-gradient(to bottom, #486bb9 0%, #000000 100%);
        background-size: 150% 150%;
    }
    .main-panel{
       background-color: #ebeef1!important;
    }
    .main-panel > .footer {
        margin-top: 10px !important;
    }
    /*Tabela*/
    .vgt-global-search {
        background: -webkit-gradient(linear,left top, left bottom,from(#ffffff),to(#ffffff))!important;
        background: linear-gradient(#ffffff,#fefefe)!important;
        padding-top: 21px !important;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        padding-left: 20px !important;
        padding-right: 20px !important;
    }
    .vgt-wrap__footer {
        background: -webkit-gradient(linear,left top, left bottom,from(#f4f5f8),to(#f1f3f6)) !important;
        background: linear-gradient(#ffffff,#ffffff) !important;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
    } 
    .vgt-responsive{
       background-color: white;
       border: 1px solid #dcdfe6;
       padding: 20px;
    }
    .vgt-table thead th {
        background: -webkit-gradient(linear,left top, left bottom,from(#ffffff),to(#ffffff))!important;
        background: linear-gradient(#ffffff,#ffffff)!important;
    }
</style>

<style scoped>
  .sidebar .nav li .nav-link p, body > .navbar-collapse .nav li .nav-link p{
    font-size: 11px !important;
  }
  .sidebar .nav li .nav-link i, body > .navbar-collapse .nav li .nav-link i {
    font-size: 24px !important;
    width: 19px !important;
  }
</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  import axios from "axios";
  import store from "src/store.js"
  import "src/controller/sistema/usuarioController.js"
  import "src/controller/sistema/permissaoController.js"
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    data() {
      return {
       m_loading: false,
       permiss:[],
       minha:{
         cidadao: 1,
         manifestacao: 1,
         editor: 1,
         mod_departamento:1,
       },
       user: {
        admin: null,
        admin_sistema: null,
        editor: null,
        tipo:null,
        grupo:null,
       },
       loading: `/img/loading.gif`,
       funcoes:3,
      }
    },
  
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      async permissao() {
        try {
          let data = await this.$listarPermissoes();

          this.permiss = data.data;
          this.user.admin = store.admin;
          this.user.admin_sistema = store.admin_sistema;
          this.user.editor = store.editor;
          this.user.tipo = store.tipo;
          this.user.grupo = store.grupo;

          
          this.permiss.forEach((element) => {
            if (store.grupo == element.id) {
              this.minha.cidadao = element.hab_cidadao;
              this.minha.manifestacao = element.hab_manifestacao;
              this.minha.mod_departamento = element.hab_mod_departamento;
            }
          });
          
          
          setTimeout(() => { this.m_loading = true;}, 1500);    

        }catch(e){

        }
      }
    },
    async beforeMount() {
      try {
        this.permissao();
        
        let res = await axios.get('tipousuario/'+store.tipo);
        this.funcoes = res.data.data;

      } catch (e) {}
    }
  }

</script>

<style >
   .loading{
     position: absolute;
     top: 50%;
     left: 50%;
     margin-right: -50%;
     transform: translate(-50%, -50%);
   }
</style>